import { useQuery } from "@apollo/client";
import { MY_HR_GET_CHANGE_REQUESTS_EXAMINERS_NAME } from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrChangeRequestsExaminersName = ({
  locale,
  contract,
}: {
  locale: string;
  contract: string;
}) => {
  const { data, loading, error } = useQuery(
    MY_HR_GET_CHANGE_REQUESTS_EXAMINERS_NAME,
    {
      skip: !contract,
      fetchPolicy: "cache-and-network",
      pollInterval: useOcPolling(1000 * 60),
      variables: { locale, contract },
    },
  );

  const result = data?.getChangeRequestsExaminersName || [];

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyHrChangeRequestsExaminersName;
